export default __webpack_public_path__ + "static/media/P104.5.fb42d34a.mp3";